module.exports = __webpack_public_path__ + "static/media/36.e4dbbcc8.png";